module.exports = __webpack_public_path__ + "img/people.56a508d0.png";